import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';
import useAnimation from './useAnimation';

const PageViewSlider = styled.span`
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.shades[1]};
  position: absolute;
  padding: 10px;
  z-index: 1;
  transform: translate(-50%, -50%);
  left: -50%;
  top: 50%;
  background: rgba(255, 255, 255, 0.8);
  transition: 1s;
  visibility: hidden;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  display: flex;
  path.dc-no-fill {
    fill: ${({ theme, isFlameIcon }) => (isFlameIcon ? theme.colors.shades[7] : 'none')};
    stroke-width: 2px;
  }
  &.pageViewSlideIn {
    left: 50%;
    visibility: visible;
  }
`;

const PageViewIcon = styled(Icon)`
    svg {
      height: 22px;
    }
`;
const MessageSection = styled.span`
    margin:  ${({ margin }) => margin};
`;

const AnimatedMessage = ({
  message, iconType, timeout, delay, min, max, valueTrimmed
}) => {

  const { slideClass, setSliderClass } =
    useAnimation(parseInt(timeout || 0, 10), parseInt(delay || 0, 10));

  return (
    <div
      className={'animated-message'}
      data-delay={delay}
      data-timeout={timeout}
      data-value-trimmed={valueTrimmed}
      data-min={min}
      data-max={max}
    >
      <PageViewSlider
        onClick={() => setSliderClass('')}
        className={slideClass}
        isFlameIcon={iconType === 'Flame'}
      >
        <PageViewIcon icon={iconType} />
        <MessageSection
          margin={iconType === 'Flame' ? '5px 0 0 8px' : '2px 0 0 16px'}
        >
          {message}
        </MessageSection>
      </PageViewSlider>
    </div>

  );
};
AnimatedMessage.propTypes = {
  message: PropTypes.string.isRequired,
  iconType: PropTypes.oneOf(['Flame', 'Eye']).isRequired,
  delay: PropTypes.string.isRequired,
  timeout: PropTypes.string.isRequired,
  min: PropTypes.string.isRequired,
  max: PropTypes.string.isRequired,
  valueTrimmed: PropTypes.string.isRequired
};
 

export default AnimatedMessage;
